import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import Button from '@mui/material/Button';
import {useHistory} from "react-router-dom";
import Footer from "../components/Footer";
import TopBarHeader from "../components/TopBarHeader";
import {makeStyles} from "@material-ui/core/styles";
import ReactGA4 from "react-ga4";
import {useAddressPosition, useDataResponse, useMarkersPosition, useMenu, useQueryParameters} from "../utils/recoil";
import {LoadScript} from "@react-google-maps/api";
import Search from "../components/Search";
import AppLoader2 from "../components/Apploader2";
import ModalWindowError from "../components/ModalWindowError";
import {WindowSize} from "../utils/functionality";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiButton-root": {
            backgroundColor: "#FCB01F",
            "&:hover": {
                //you want this to be the same as the backgroundColor above
                backgroundColor: "#E3A01B"
            },
            "&:focus": {
                //you want this to be the same as the backgroundColor above
                backgroundColor: "#C98E18",
            }
        }
    }
}));
const libraries = ["places"]
export default function Page1() {
    const {t, i18n} = useTranslation()
    const classes = useStyles();
    const [menu, setMenu] = useMenu()
    const [showWindow, setShowWindow] = useState(false)
    const [loader, setLoader] = useState(false)
    const [addressStart, setAddressStart] = useState('')
    const [addressStartRecoil, setAddressStartRecoil] = useAddressPosition()
    const [dataAll, setDataAll] = useDataResponse()
    const [markers, setMarkers] = useState([])
    const [MarkersR, setMarkersR] = useMarkersPosition()
    const [query, setQuery] = useQueryParameters()
    const [elevation, setElevation] = useState(0)

    let history = useHistory();
    const queryString = require('query-string');
    // eslint-disable-next-line no-restricted-globals
    const parsed = queryString.parse(location.search);

    useEffect(() => {
        let id
        if (Object.keys(parsed).length) {
            id = parsed?.id
            setQuery({
                ...query, Email: parsed?.email || "", id: parsed?.id || 111111,
                CompanyName: parsed?.company || "K2Go",
                Language: parsed?.language || 'de'
            })
            sessionStorage.setItem("query", JSON.stringify({
                ...query, Email: parsed?.email || "", id: parsed?.id || 111111,
                CompanyName: parsed?.company || "K2Go",
                Language: parsed?.language || 'de'
            }))
        } else {
            if(JSON.parse(sessionStorage.getItem("query"))){
                setQuery({...JSON.parse(sessionStorage.getItem("query"))})
                id =JSON.parse(sessionStorage.getItem("query")).id
            }
        }

        console.log("initialize", id)
        ReactGA4.initialize([
            {
                trackingId: process.env.REACT_APP_MEASUREMENT_ID,
                gaOptions: {
                    userId: id
                },
                gtagOptions: {
                    userId: id
                },
            },
        ])
        ReactGA4.set({
            user_id: id
        })
    }, [])

    useEffect(() => {
            ReactGA4.event({category: 'event', action: '1 - Intro screen', label: '1 - Intro screen'})
            ReactGA4.event({category: 'event', action: '2 - Enter your address', label: '2 - Enter your address'})
    }, [])

    // function handleClick() {
    //     history.push("page2");
    //     ReactGA4.event({category: 'event', action: 'begin'})
    // }
    const center = {
        lat: 47.373878,
        lng: 8.545094
    }

    function handleClick() {
        history.push("/result");
    }

    WindowSize(setMenu);
    const handleClose = () => {
        setShowWindow(false)
    }

    function getDataReport() {
        ReactGA4.event({category: 'event', action: 'generate_report'})
        setLoader(true)
        setAddressStartRecoil(addressStart)
        sessionStorage.setItem("address", JSON.stringify(addressStart))
        // sessionStorage.setItem("Center",JSON.stringify(markers[0]))

        const token = "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJKT3dZN0JlbkZJc3RDUjRKdk1NLVkzMDdBTU5wQTY5WXByVFhSOXJWd21jIn0.eyJleHAiOjE3NDc5MDQxNTAsImlhdCI6MTcxNjgwMDE1MCwianRpIjoiNmYyMmNmMzYtNmM3ZC00OTA3LTliMDctYTgxM2FmNTM0NDEzIiwiaXNzIjoiaHR0cHM6Ly9rZXljbG9hay5rYXNrbzJnby5vcmcvcmVhbG1zL2JhbGNpYS1ycnIiLCJzdWIiOiI2MGI0Yzc1OS0yZDFhLTQxMWQtOWZjMS0xMmFkMGRlZGViNjgiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJhZG1pbi1jbGkiLCJzZXNzaW9uX3N0YXRlIjoiZDIzNTI1MzUtZDAxYy00NTM2LWE5MzYtNjM1ZmViZTZlYTJmIiwiYWNyIjoiMSIsInNjb3BlIjoiZW1haWwgcHJvZmlsZSIsInNpZCI6ImQyMzUyNTM1LWQwMWMtNDUzNi1hOTM2LTYzNWZlYmU2ZWEyZiIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJuYW1lIjoiQmFsY2lhIENvcnBvcmF0aXZlIEFjY291bnQiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJiYWxjaWEtcnJyIiwiZ2l2ZW5fbmFtZSI6IkJhbGNpYSIsImZhbWlseV9uYW1lIjoiQ29ycG9yYXRpdmUgQWNjb3VudCIsImVtYWlsIjoiYmFsY2lhQGthc2tvbzJnby5vcmcifQ.d7qOutjN8AJ1UYEhuNRswP4-rSG9juNeT4L0Nbt_Sn-_gS0CDDXdE8rRS1XLSxnPDO_ojVJhxcDmLHqTkYbOKDRnm6liKav3sos4wyZ65VBrQ8uZbcu3duW-g3-S-NQaD92hNYnM8JSHN1EZFbi1Lcyk5hVkc9K2OsEbZ2pChtUUXPaWHZ_XiVaE7czyS-mWdUlhFiNewF8fnTx66xRJ0iYPuPSCAjNApAtGSGrrNG6akSVbeV6La9v7gnyVjz_YuO3MWDVkL1uXXpslz0Lz8ZgUrsIHpYaq5t3QFVkWwP0byR5vytcDHYesV1lfG_PAUwrQEEeG_xu7Wbuxpp_gmg"

        setMarkersR(markers[0])
        let config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Access-Control-Allow-Origin': '*',
                'accept': '*/*',
                'accept-encoding': 'gzip, deflate, br, zstd',
                'access-control-request-headers': 'access-control-allow-origin,authorization',
                'access-control-request-method': 'GET,OPTIONS',
                'cache-control': 'no-cache',
                'origin': 'https://demo.kasko2go.org',
                'sec-fetch-dest': 'empty',
                'sec-fetch-mode': 'cors',
                'sec-fetch-site': 'same-site'
            },
            params: {
                latitude: markers[0].lat,
                longitude: markers[0].lng,
                // AddressLat: markers[0].lat,
                // AddressLon: markers[0].lng,
                // Email: query.Email || '',
                // Address: addressStart,
                // PhoneNumber: query.id,
                // CompanyName: query.CompanyName || "K2Go",
                // WithReport: true
            }
        }
        axios.get(process.env.REACT_APP_API_URL, config).then((response) => {
            setDataAll({...response.data})
            sessionStorage.setItem("reportData", JSON.stringify({...response.data}))
            handleClick()
        }).catch((error => {
            setShowWindow(true)
            // setAddressStart('')
            ReactGA4.event({category: 'event', action: 'wrong_country', label: addressStart})
            console.log(error)
        })).finally(() => {
            setLoader(false)
        })
    }

    useEffect(() => {
        window.onscroll = function () {
            if (window.scrollY !== 0) {
                setElevation(3)
            } else {
                setElevation(0)
            }
        };
    }, [window.scrollY])
    return (<>
        <TopBarHeader elevation={elevation}/>
        <div className="mainContainer">
            <main className="bodyPage1Small">
                <div className="mainTitlePage1" style={{maxWidth:452}}>
                    {t('intro_title')}
                </div>
                <div className="subTitle"  style={{maxWidth:452,marginBottom:40}}>
                    {t('intro_subtitle')}
                    {/*Please enter your address, so that we can generate your risk report*/}
                </div>

                <LoadScript
                    id="script-loader"
                    googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                    language={i18n.language}
                    region={'CH'}
                    libraries={libraries}
                    version="weekly">
                    <Search setAddressPosition={setAddressStart} addressPosition={addressStart} center={center}
                            setMarkers={setMarkers} width={window.innerWidth > 1023 ? 544 : 452}
                            placeholder={t('address_field')}/>
                </LoadScript>
                <div className="image-wrapper" style={{textAlign: 'center'}}>
                    <div className={classes.root}>
                        <Button disableRipple variant="contained" className="button" disabled={!markers[0]}
                                onClick={getDataReport}
                                style={{backgroundColor: loader ? "#F5F5F5" : !markers[0] ? "#D8D7D7" : "#FCB01F"}}>
                            <AppLoader2 children={<span className="textButton">
                                {t('address_btn')}
                                {/*Generate report*/}
                            </span>} loading={loader}/>
                        </Button>
                    </div>
                </div>
                <div className="image-wrapper" style={{marginTop:20}}>
                    <img alt="" src="/images/berlin 1.png"/>
                </div>
            </main>
            <main className="bodyPage1">
                <div className="mainTitlePage1">
                    {t('intro_title')}
                </div>
                <div className="subTitle">
                    {t('intro_subtitle')}
                    {/*Please enter your address, so that we can generate your risk report*/}
                </div>
                <div className="image-wrapper gapAfterImage">
                    <img alt="" src="/images/berlin 1.png"/>
                </div>
                <LoadScript
                    id="script-loader"
                    googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                    language={i18n.language}
                    region={'CH'}
                    libraries={libraries}
                    version="weekly">
                    <Search setAddressPosition={setAddressStart} addressPosition={addressStart} center={center}
                            setMarkers={setMarkers} width={window.innerWidth > 1023 ? 544 : 452}
                            placeholder={t('address_field')}/>
                </LoadScript>
                <div className="image-wrapper" style={{textAlign: 'center'}}>
                    <div className={classes.root}>
                        <Button disableRipple variant="contained" className="button" disabled={!markers[0]}
                                onClick={getDataReport}
                                style={{backgroundColor: loader ? "#F5F5F5" : !markers[0] ? "#D8D7D7" : "#FCB01F"}}>
                            <AppLoader2 children={<span className="textButton">
                                {t('address_btn')}
                                {/*Generate report*/}
                            </span>} loading={loader}/>
                        </Button>
                    </div>
                </div>
            </main>
            <main className="body2Page1">
                <div className="flexSpaceBetween" style={{maxWidth: 954, marginBottom: 60}}>
                    <div>
                        <div className="mainTitlePage1">
                            {t('intro_title')}
                        </div>
                        <div className="subTitlePage1">
                            {t('intro_subtitle')}
                            {/*Please enter your address, so that we can generate your risk report*/}
                        </div>


                    </div>
                    <img alt="" className='img-first-page' src="/images/berlin 1.png"/>
                </div>
                <div className="flexSpaceBetween" style={{maxWidth: 954, marginBottom: 80}}>
                    <div style={{width: 544}}>
                        <LoadScript
                            id="script-loader"
                            googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                            language={i18n.language}
                            region={'CH'}
                            libraries={libraries}
                            version="weekly">
                            <Search setAddressPosition={setAddressStart} addressPosition={addressStart} center={center}
                                    setMarkers={setMarkers} width={544} placeholder={t('address_field')}/>
                        </LoadScript>
                    </div>
                    <div className={classes.root}>
                        <Button disableRipple variant="contained" className="buttonPage1" disabled={!markers[0]}
                                onClick={getDataReport}
                                style={{backgroundColor: loader ? "#F5F5F5" : !markers[0] ? "#D8D7D7" : "#FCB01F"}}>
                            <AppLoader2 children={<span className="textButton">
                                {t('address_btn')}
                            </span>} loading={loader}/>
                        </Button>
                    </div>
                </div>
            </main>
        </div>
        <Footer/>
        <ModalWindowError open={showWindow} handleClose={handleClose}/>
    </>)
}

